import { render, staticRenderFns } from "./TrustedBySection.vue?vue&type=template&id=37c783ce"
import script from "./TrustedBySection.vue?vue&type=script&lang=js"
export * from "./TrustedBySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports